<div class="product-mix-row">
  <div class="mat-elevation-z8 inline-table">
    <table mat-table [dataSource]="allowedProductsDatasource" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="'customWidthClass'">
          {{ 'labels.inputs.Allowed Products' | translate }}
        </th>
        <td mat-cell *matCellDef="let product" [ngClass]="'customWidthClass'">{{ product.name }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="allowedProductsDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: allowedProductsDisplayedColumns"></tr>
    </table>

    <mat-paginator #allowed [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
  <div class="restricted-products-col">
    <div class="action-buttons">
      <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_PRODUCTMIX'">
        <fa-icon icon="edit" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Edit' | translate }}
      </button>
      <button mat-raised-button color="warn" (click)="delete()" *LOSxHasPermission="'DELETE_PRODUCTMIX'">
        <fa-icon icon="trash" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Delete' | translate }}
      </button>
    </div>
    <div class="mat-elevation-z8 inline-table restricted-products-box">
      <table mat-table [dataSource]="restrictedProductsDatasource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'labels.inputs.Restricted products' | translate }}
          </th>
          <td mat-cell *matCellDef="let product">{{ product.name }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="restrictedProductsDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: restrictedProductsDisplayedColumns"></tr>
      </table>

      <mat-paginator #restricted [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
